import { render, staticRenderFns } from "./painelclasses.vue?vue&type=template&id=36da7e40&"
import script from "./painelclasses.vue?vue&type=script&lang=js&"
export * from "./painelclasses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports